import AppBar from '@mui/material/AppBar';
import Link from 'next/link';
import Tab from '@mui/material/Tab';
import TabList from '@mui/lab/TabList';
import Typography from '@mui/material/Typography';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import * as ProfileTabBarStyles from './ProfileTabBar.styles';
import tracking from '../../../../utils/tracking';
import { PrivateRoutePath } from '../../../../utils/routes';
import { TrackingLinkEvent } from '../../../../utils/tracking/types';

function ProfileTabBar() {
  const { classes } = ProfileTabBarStyles.useStyles();

  const linkRef = useRef<HTMLAnchorElement>(null);

  const linkRefCurrent = linkRef.current;

  useEffect(() => {
    if (linkRefCurrent) tracking.trackLink(linkRefCurrent, TrackingLinkEvent.PRICING_PLAN_TAB_SELECTED);
  }, [linkRefCurrent]);

  return (
    <AppBar classes={{ root: classes.root }} elevation={0} color="default" position="static">
      <TabList
        classes={{ indicator: classes.tabIndicator, flexContainer: classes.tabsFlexContainer }}
        aria-label="profile tabs"
        id="profile-tabs"
      >
        <Tab
          value={PrivateRoutePath.PROFILE}
          classes={{ root: classes.tab }}
          disableRipple
          component="div"
          id={`${PrivateRoutePath.PROFILE_PRICING_PLAN}-tab`}
          label={
            <Link href={PrivateRoutePath.PROFILE} passHref>
              <Typography component="a" variant="button">
                My details
              </Typography>
            </Link>
          }
        />
      </TabList>
    </AppBar>
  );
}

export default ProfileTabBar;
